/* angular:styles/component:css;b7b6c3cf7a20b518944ace178142736cc950b2b101799454b45c64d2ab1087cd;/src/src/app/index/shared/sumState.ts */
.sum-state-icon > ion-icon {
  font-size: 20pt !important;
}
/*# sourceMappingURL=sumState.css.map */
